import React, { createContext, Component } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

const Responsive = createContext();
const Provider = Responsive.Provider;
const IDENTIFY_COOKIE = `mp_vp`; // marketplace viewport, lol

/*
	* Wraps a component to use Context to check responsiveness
	*
	* @returns {Object}
*/
export class ResponsiveProvider extends Component {
	state = {
		isMobile: this.props.isMobile,
		isTablet: this.props.isTablet,
		isDesktop: this.props.isDesktop,
	}

	getBodyWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

	minWidth = value => this.getBodyWidth() >= value

	maxWidth = value => this.getBodyWidth() <= value

	isBetween = (min, max) => this.minWidth(min) && this.maxWidth(max)

	debouncer = null;

	debounce = () => {
		const DEBOUNCE_RATE = this.props.debounceRate;
		if (this.debouncer) clearTimeout(this.debouncer);
		this.debouncer = setTimeout(this.handleResize, DEBOUNCE_RATE);
	}

	handleResize = () => {
		const { desktopMinWidth, tabletMinWidth } = this.props;
		const mobileMaxWidth = tabletMinWidth - 1;
		const tabletMaxWidth = desktopMinWidth - 1;
		const isMobile = this.maxWidth(mobileMaxWidth);
		const isTablet = this.isBetween(tabletMinWidth, tabletMaxWidth);
		const isDesktop = this.minWidth(desktopMinWidth);

		this.setState({ isMobile, isTablet, isDesktop }, this.handleCookies);
	}

	handleCookies = () => {
		const currentWidth = this.getBodyWidth();
		const savedCookie = Cookies.get(IDENTIFY_COOKIE);
		if (savedCookie && savedCookie === currentWidth) return;
		Cookies.set(IDENTIFY_COOKIE, currentWidth);
	}

	componentDidMount () {
		this.handleResize();
		window.addEventListener('resize', this.debounce);
	}

	componentWillUnmount () {
		window.removeEventListener('resize', this.debounce);
	}

	render () {
		return (
			<Provider value={this.state}>
				{this.props.children}
			</Provider>
		);
	}
}

ResponsiveProvider.defaultProps = {
	debounceRate: 100,
	desktopMinWidth: 1024,
	tabletMinWidth: 768,
	isMobile: true,
	isTablet: false,
	isDesktop: false,
};

ResponsiveProvider.propTypes = {
	children: PropTypes.node,
	debounceRate: PropTypes.number,
	desktopMinWidth: PropTypes.number,
	tabletMinWidth: PropTypes.number,
	isMobile: PropTypes.bool,
	isTablet: PropTypes.bool,
	isDesktop: PropTypes.bool,
};

/*
	* Provide children down the tree with a way to check responsiveness
	* @param {Function} ReactStateless - Takes our state from above as params
*/
export const ResponsiveCheck = Responsive.Consumer;

export default Responsive;
